import React from 'react';
import _HighlightNeedOfferTab from './_HighlightNeedOfferTab.scss';
import {
  HighlightNeedOfferList
} from './HighlightNeedOffer';
import {Demands} from 'api';
import {Link, withRouter} from 'react-router-dom';

class HighlightNeedOfferTab extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      limit: 3,
      data: []
    }
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit
      }
    };
    Demands.actions.count.request(params).then(response => {
      this.setState({
        data: response.data
      });
    });
  }

  render() {
    return (
      <section className="highlight-needoffer-tab" style={{backgroundImage: `Url(${require('assets/images/home/background.png')})`}}>
        <div className='highlight-needoffer-content left-content'>
          <img className='highlight-needoffer-img' src={require('assets/images/home/Bitmap.png')}/>
        </div>
        <div className='highlight-needoffer-content right-content'>
          <h2 className='highlight-needoffer-title'>Tiếp cận nhu cầu một cách nhanh chóng</h2>
          <HighlightNeedOfferList/>
          <p className='view-more-item'>
            <Link to='/demands' className='view-more-link'>XEM THÊM {this.state.data.count} NHU CẦU</Link>
            {/* chưa có route list demand */}
          </p>
        </div>
      </section>
    );
  }
}

export default withRouter(HighlightNeedOfferTab);



// WEBPACK FOOTER //
// ./components/home/sub-view/HighlightNeedOfferTab.jsx